import { Paths } from '../../../../lib/constants/path'

export const constructOlPersonalSpaceCenterPath = (path: string, olId: number) =>
  Paths.OL_PERSONAL_SPACE_CENTER_DETAILS_PAGE.replace(':id', olId.toString()).replace('*', '') +
  path
